var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1396 10.3885C17.1396 10.3885 17.1511 10.3827 17.1796 10.377C17.4654 10.2742 19.2425 9.59988 19.2425 8.31988C19.2425 7.50845 18.5054 7.11988 17.9111 7.09131",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49949 10.3887C9.49949 10.3887 9.48806 10.383 9.45949 10.3772C9.17377 10.2744 7.40234 9.6001 7.40234 8.3201C7.40234 7.89724 7.59663 7.58867 7.87663 7.38867",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3112 15.2114L6.56832 16.84C5.94546 17.0514 5.52832 17.64 5.52832 18.2971V25H21.0426V18.2971C21.0426 17.64 20.6255 17.0514 20.0026 16.84L15.2598 15.2114",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2881 13.2798L11.3109 15.2112L13.2881 16.4741L15.2652 15.2112L15.2881 13.2798",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40234 8.30268V9.74839C9.40234 9.95982 9.41949 10.1712 9.45949 10.3712C9.5852 11.1998 9.97949 11.9484 10.5509 12.5141C11.2538 13.2227 12.2366 13.6627 13.3166 13.6627C15.2595 13.6627 16.8823 12.2341 17.1738 10.3655C17.2138 10.1655 17.2309 9.95411 17.2309 9.74268V8.30839C16.4366 8.06268 16.2252 7.26268 16.2252 7.26268C13.3566 7.66268 11.3623 6.46268 10.6709 5.9541C10.6766 5.87982 10.6823 5.81125 10.6823 5.74268",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.688 5.74875C10.688 5.81732 10.6822 5.88589 10.6765 5.96018C10.6022 6.66875 10.3051 7.58875 9.40796 8.29732L9.39653 8.30875C8.75653 8.81161 8.19081 8.26304 7.88224 7.37732C7.35653 5.88018 7.56796 3.41732 9.43081 3.42875H9.43653C10.3851 3.44018 10.648 4.85161 10.648 4.85161C10.648 4.85161 10.728 5.21732 10.6937 5.74304L10.688 5.74875Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2312 8.31429C17.2312 8.31429 18.1855 7.46286 18.1855 5.09143C18.1855 2.84571 15.5569 1 13.0198 1C11.3283 1 9.62549 2.02286 9.41406 3.43429",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2885 16.4743L11.2085 17.5714L10.3799 15.5314L11.3113 15.2114L13.2885 16.4743Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2881 16.4743L15.3681 17.5714L16.1967 15.5314L15.2652 15.2114L13.2881 16.4743Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1336 17.0798L12.8021 17.8798L11.625 22.0627L13.2879 23.4627L14.9507 22.0627L13.7736 17.8798L14.4421 17.0798L13.2879 16.4741L12.1336 17.0798Z",
    stroke: "#A3A3A3",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.eacde979330f346bd7a74f5ecbed4c44.svg";
export { ForwardRef as ReactComponent };